// Which partners serve a customer (#1195; the decision is #1187's). The server derives it by
// one rule, `partners_of`; these read what it answers and derive nothing of their own.

import type { OrgRow, PartnerRef } from "../api/customers";
import { orgKindName } from "../api/memberships";

/** "Acme", "Acme and Northwind", "Acme, Northwind and Southgate". */
function listed(names: string[]): string {
  return names.length < 2 ? names.join("") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}

/** The partners a reader may name. One whose name its lane cannot read is left unsaid. */
function named(partners: PartnerRef[] | undefined): string[] {
  return (partners ?? []).flatMap((p) => (p.name === null ? [] : [p.name]));
}

/** The platform list's Type cell: "Partner", "Customer", or "Customer · managed by Acme". */
export function orgTypeText(org: OrgRow): string {
  const kind = orgKindName(org.kind);
  const partners = named(org.managed_by);
  return partners.length === 0 ? kind : `${kind} · managed by ${listed(partners)}`;
}

/**
 * The workspace's Partner access page: "Managed by <Partner>", one line for each partner
 * serving this workspace (the session's `partners` is per workspace), kept apart by id.
 */
export function ManagedBy({ partners }: { partners: PartnerRef[] | undefined }) {
  const shown = (partners ?? []).filter((p): p is PartnerRef & { name: string } => p.name !== null);
  if (shown.length === 0) return null;
  return (
    <section className="panel" aria-labelledby="managed-by-heading">
      <div className="panel__head">
        <h2 id="managed-by-heading">Partners serving this workspace</h2>
      </div>
      {shown.map((partner) => (
        <p className="panel__body" key={partner.id}>
          Managed by {partner.name}
        </p>
      ))}
    </section>
  );
}
